export default {
	title: 'Art.51 – Plateforme Innovation',
	logoBtn: {
		label: 'Accueil',
		alt: 'l’Assurance Maladie'
	}
};
